// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '한국파마',
  targetSheetName: 'CSO 요율표',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    price: '보험약가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No.',
    '처방약호',
    '보험코드',
    '질환군',
    '처방약호명',
    '성분명',
    '보험약가',
    '수수료',
    '비고',
    '생산',
  ],
});
